// packages import
import { Box, Typography } from '@mui/material'
import { Maybe } from 'graphql/jsutils/Maybe'
import { FC } from 'react'

// component imports

// others
import { Case } from '../../../../generated'
import MatterDropdown from '../../common/MatterDropdown'

interface MatterFilterProps {
  matterId: any
  setReportFilters: any
  userId?: string
}

const MatterFilter: FC<MatterFilterProps> = ({ matterId, setReportFilters, userId }) => {
  const handleMatterChange = (value: Maybe<Case>) => {
    setReportFilters((prev: any) => ({ ...prev, matterId: value?.id }))
  }

  // The hint is absolutely positioned so it sits below the field without adding
  // height to it. The filters row is bottom-aligned (alignItems: 'end'), so an
  // in-field helperText would push this dropdown above the others — this keeps
  // the field box aligned regardless of where the Matter filter appears in the row.
  return (
    <Box sx={{ position: 'relative', width: '300px' }}>
      <MatterDropdown
        customOnChange={handleMatterChange}
        label="Matter"
        sx={{ width: '100%' }}
        includeClosedMatters
        userId={userId}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ position: 'absolute', top: '100%', left: 0, mt: 0.25, lineHeight: 1.2 }}
      >
        Includes closed &amp; completed matters
      </Typography>
    </Box>
  )
}

export default MatterFilter
